import Api from 'api';
import {
  CLEAR_AUTH,
  COMPLETE_INFO,
  UPDATE_INFO, // Agregar UPDATE_INFO
  LOGIN,
  RECOVER_PASSWORD,
  SET_COMPANY,
  SET_SUBCOMPANY,
  VERIFY_TOKEN,
  LOAD_SESSION,
} from 'auth/constants';

import { GET_COMPANIES } from 'companies/constants';

export const login = (email, password) => (dispatch) =>
  dispatch({
    type: LOGIN,
    payload: Api.auth.login(email, password).then((r) => {
      r.user &&
        r.user.companies &&
        dispatch({
          type: GET_COMPANIES,
          payload: { companies: r.user.companies },
        });
      return r;
    }),
  });

export const recoverPassword = (email) => (dispatch) =>
  dispatch({
    type: RECOVER_PASSWORD,
    payload: Api.auth.recoverPassword(email),
  });

export const resetPassword = (token, password) => (dispatch) =>
  dispatch({
    type: RECOVER_PASSWORD,
    payload: Api.auth.resetPassword(token, password),
  });

export const completeInfo = (token, password) => (dispatch) =>
  dispatch({
    type: COMPLETE_INFO,
    payload: Api.auth.completeInfo(token, password),
  });

export const updateInfo = (token, password) => (dispatch) =>
  dispatch({
    type: UPDATE_INFO,
    payload: Api.auth.updateInfo(token, password),
  });

export const verifyToken = (token) => (dispatch) =>
  dispatch({
    type: VERIFY_TOKEN,
    meta: { needAuth: true },
    payload: Api.auth.verifyToken(token),
  }).then(({ value }) => {
    value.user &&
      value.user.companies &&
      dispatch({
        type: GET_COMPANIES,
        payload: { companies: value.user.companies },
      });
    return value;
  });

export const clearAuth = () => ({ type: CLEAR_AUTH });

export const setCompany = (company) => ({ type: SET_COMPANY, payload: company });

export const setSubcompany = (subcompany) => ({
  type: SET_SUBCOMPANY,
  payload: subcompany,
});

export const logout = () => {
  Api.auth.logout();
  return clearAuth();
};

export const loadSession = () => (dispatch) => {
  const token = Api.auth.getToken();
  const user = Api.auth.getUser();
  if (user && token) {
    dispatch({ type: LOAD_SESSION, payload: { token, user } });
    dispatch({ type: GET_COMPANIES, payload: user });
  } else {
    dispatch(logout());
  }
};



// WEBPACK FOOTER //
// src/modules/auth/actions/auth_actions.js